import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import ProjectSearch from "../components/ProjectSearch";

import UserTable from "../components/UserTable";

import { CSVLink, CSVDownload } from "react-csv";

function ProjectDetail() {
  const { projectId } = useParams();
  const [loading, setLoading] = useState(false);
  const [projectData, setProjectData] = useState(null);
  const [users, setUsers] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [searchResults, setSearchResults] = useState([]); // Common state for search results
  // console.log("searchResults", searchResults);

  const host = process.env.REACT_APP_SERVER;

  useEffect(() => {
    const fetchProjectData = async () => {
      setLoading(true);

      try {
        const response = await fetch(`${host}/api/projects/${projectId}`);
        const jsonData = await response.json();
        setProjectData(jsonData.data.project);
        setUsers(jsonData.data.project.users);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectData();
  }, [projectId]);

  useEffect(() => {
    const fetchProjectData = async () => {
      setLoading(true);

      try {
        const response = await fetch(`${host}/api/projects/${projectId}`);
        const jsonData = await response.json();
        setProjectData(jsonData.data.project);
        setUsers(jsonData.data.project.users);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectData();
  }, [projectId]);

  useEffect(() => {
    const fetchUpdatedUserData = async () => {
      try {
        const response = await fetch(`${host}/api/projects/${projectId}`);
        const jsonData = await response.json();
        setUsers(jsonData.data.project.users);
      } catch (error) {
        console.error(error);
      }
    };

    // Only run this effect when projectId changes
    fetchUpdatedUserData();
  }, [projectId]);

  // Rest of your component code...

  const onBookmarkToggle = async (usersToToggle, bookmark = null) => {
    console.log("bookmark", bookmark);
    // Update the common state (users)
    const updatedUsers = users.map((u) => {
      const matchingUser = usersToToggle.find((user) => user.id === u.id);
      // console.log("matchingUser", matchingUser);
      return matchingUser ? { ...u, bookmarked: bookmark ? bookmark : !u.bookmarked } : u;
    });

    setUsers(updatedUsers);

    // Update the search results if the user is found there
    const updatedSearchResults = searchResults.map((u) => {
      const matchingUser = usersToToggle.find((user) => user.id === u.id);
      // console.log("Call list matchingUser", matchingUser);
      return matchingUser ? { ...u, bookmarked: !u.bookmarked } : u;
    });

    setSearchResults(updatedSearchResults);

    // Fetch updated data from the API
    try {
      const response = await fetch(`${host}/api/projects/${projectId}`);
      const jsonData = await response.json();
      setUsers(jsonData.data.project.users);
    } catch (error) {
      console.error(error);
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!projectData) {
    return <p>Project not found.</p>;
  }

  return (
    <div className="container mx-auto w-full pl-5">
      <div className="text-sm breadcrumbs pb-5">
        <ul>
          <li>
            <Link to={`/`} className="text-blue-500">
              <a>Home</a>
            </Link>
          </li>
          <li>
            <Link to={`/projects`} className="text-blue-500">
              <a>Projects</a>
            </Link>
          </li>
          <li>
            <Link to={`/projects/${projectId}`} className="text-blue-500">
              <a>{projectId}</a>
            </Link>
          </li>
        </ul>
      </div>
      <div className="flex flex-wrap">
        <div className="w-full">
          <article className="prose">
            <div>
              <div>
                <h1 className="text-3xl font-bold mb-0 mr-2">{projectData.name}</h1>
              </div>
            </div>
          </article>
          <div className="divider" />
          <div className="tabs mb-4">
            <h2 className={`tab tab-lifted ${activeTab === 0 ? "tab-active" : ""}`} onClick={() => setActiveTab(0)}>
              Info
            </h2>
            <h2 className={`tab tab-lifted ${activeTab === 1 ? "tab-active" : ""}`} onClick={() => setActiveTab(1)}>
              Current List
            </h2>
            <h2 className={`tab tab-lifted ${activeTab === 2 ? "tab-active" : ""}`} onClick={() => setActiveTab(2)}>
              Search
            </h2>
          </div>
          {activeTab === 0 && <ProjectInfo projectData={projectData} />}
          {activeTab === 1 && <UserList users={users} projectId={projectId} onBookmarkToggle={onBookmarkToggle} isCurrentList={true} />}
          {activeTab === 2 && (
            <ProjectSearch
              projectId={projectId}
              searchResults={searchResults} // Pass the search results to the search component
              onBookmarkToggle={onBookmarkToggle} // Pass the toggle function to the search component
              setSearchResults={setSearchResults} // Pass a function to update search results from the search component
            />
          )}{" "}
        </div>
      </div>
    </div>
  );
}

export default ProjectDetail;

// ProjectInfo.js
function ProjectInfo({ projectData }) {
  return (
    <div tabIndex={0} className="collapse">
      <p className="mb-2">
        <span className="font-semibold">STATUS:</span> {projectData.status}
      </p>
      <p className="mb-2">
        <span className="font-semibold">CREATED ON:</span> {new Date(projectData.timestamp).toLocaleDateString()}
      </p>
      <p className="mb-2">
        <span className="font-semibold">CASTER:</span> {projectData.creator}
      </p>

      <p className="mb-2">
        <span className="font-semibold">CLIENT:</span> {projectData.client}
      </p>
      <p className="mb-2">
        <span className="font-semibold">CATEGORY:</span> {projectData.category}
      </p>
      <p className="mb-2">
        <span className="font-semibold">IDS:</span> {projectData.people_ids}
      </p>
    </div>
  );
}

// UserList.js
function UserList({ users, projectId, onBookmarkToggle }) {
  // Map the users array to include only the specified keys
  let updatedList = users.map((obj) => {
    return { ...obj, ["age"]: new Date().getFullYear() - obj.year_of_birth };
  });

  let preferredKeysOrder = [
    "id",
    "market",
    "name",
    "email_address",
    "phone_number",
    "age",
    "gender",
    "marital_status",
    "ethnicity",
    "occupation",
    "household_income",
    "instagram",
    "linkedin",
    "clients",
    "projects",
    "biography",
    "notes",
    "files",
    "market_self_described",
    "marital_status_self_described",
    "year_of_birth",
    "occupation_self_described",
    "household_income_self_described",
    "ethnicity_self_described",
    "phone_number_self_described",
    "gender_self_described",
    "participation",
    "called",
    "blacklist",
    "bookmarked",
  ]; // Example order

  // Loop through each object in the list
  updatedList.forEach((obj) => {
    // Add the preferred keys to the object if they're not already present
    preferredKeysOrder.forEach((key) => {
      if (!(key in obj)) {
        obj[key] = ""; // Add the key with an empty value
      }
    });
  });

  // console.log("updatedList", updatedList);
  const headers = preferredKeysOrder.map((d) => {
    return { label: d, key: d };
  });
  return (
    <div tabIndex={1} className="collapse">
      <div>
        <button className="btn btn-primary ml-2">
          <CSVLink data={updatedList} headers={headers} filename={"exported_data.csv"}>
            Export
          </CSVLink>
        </button>
      </div>

      <div className="w-full p-5">{users.length > 0 ? <UserTable users={users} projectId={projectId} onBookmarkToggle={onBookmarkToggle} isCurrentList={true} /> : <div></div>}</div>
    </div>
  );
}
